<template>
	<div class="share-reveal">
		<div class="reveal-content">
			<h3 class="share-reveal-title">{{ $t('share.title') }}</h3>
			<a :href="`https://www.facebook.com/sharer/sharer.php?u=${scrapeLink}`" class="btn-share btn-share-facebook" target="_blank" rel="nofollow noopener">
				<font-awesome-icon :icon="['fab', 'facebook']" size="2x" />
			</a>
			<a :href="`mailto:?subject=${title} - Kärnten Card&amp;body=${ $t('share.emailTxt', { title: title }) }${ encodeURIComponent('\n ------- \n' + content.split('\n')[0] +'\n\n' + shareLink) }`" class="btn-share btn-share-mail" target="_blank" rel="nofollow noopener" v-if="entity">
				<font-awesome-icon :icon="['fal', 'envelope']" size="2x" />
			</a>
			<a class="btn-share btn-share-twitter" :href="`https://twitter.com/intent/tweet?text=${ $t('share.emailTxt', { title: title }) }&url=${shareLink}`" target="_blank" rel="noopener nofollow" v-if="entity">
				<font-awesome-icon :icon="['fab', 'twitter']" size="2x" />
			</a>
			<button class="close-button" @click="$emit('close-share-reveal')" aria-label="Close modal" type="button">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>
</template>

<script>
	import foundation from '@/mixins/foundation'

	export default {
		name: 'ShareReveal',
		mixins: [ foundation ],
		props: {
			id: {
				type: String,
				default: ''
			},
			entity: {
				type: Object,
				default () {
					return {
						title: '',
						content: ''
					}
				}
			},
			shareLink: {
				type: String,
				default: ''
			},
			scrapeLink: {
				type: String,
				default: ''
			}
		},
		data () {
			return {
				title: '',
				content: ''
			}
		},
		created () {
			this.title = (this.entity.title) ? this.entity.title : ''
			this.content = (this.entity.details) ? this.entity.details.content : (this.entity.content) ? this.entity.content : ''
		}
	}
</script>

<style lang="scss">
	.share-reveal{
		padding: 0 !important;
		background-color: $light-gray;
		display: block;
		opacity: 0;
		visibility: hidden;
		transition: all .15s ease-in-out;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -2;

		&.is-reveal-open{
			z-index: 1000;
			background-color: rgba($black, .8);
			opacity: 1;
			visibility: visible;
			
			.reveal-content{
				visibility: visible;
				opacity: 1;
			}
		}

		.reveal-content{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			background-color: $white;
			visibility: hidden;
			opacity: 0;
			overflow-y: scroll;
			padding: 2rem;
			height: 100vh;

			@include breakpoint(medium) {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				max-width: rem-calc(530);
				padding: 4rem;

				height: auto;
			}
		}

		.share-reveal-title{
			width: 100%;
			margin-bottom: 1rem;
			text-align: center;
			font-size: rem-calc(21);
			font-weight: 600;
			color: get-color(primary);
		}

		.btn-share{
			@include button();
			border-radius: 50%;
			width: 4rem;
			height: 4rem;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
</style>
